import * as Yup from "yup";

export type attendanceValueTypes = {
  exportFormat: string;
  // month: string;
  startDate: string;
  endDate: string;
};

export const initalValues: attendanceValueTypes = {
  exportFormat: "CSV",
  // month: "ALL",
  startDate: "",
  endDate: "",
};

export const attendanceValidationSchema = Yup.object({
  exportFormat: Yup.string().required("Facility is Required"),
  startDate: Yup.string().required("From Date"),
  endDate: Yup.string().required("To Date"),
});
